import type { Links } from '@which/seatbelt'
import { MultiLinkBlock } from '@which/seatbelt'
import { dynamicGa4DataLayerPush } from '@which/shared'

import type { RecommendedContentType } from '../../../models'
import styles from './RecommendationsTextLinksLayout.module.scss'

const getLinks = (
  recommendations: RecommendedContentType[],
  sectionTitle: string,
  whichId: string
) => {
  const links = recommendations.map((recommendation): Links[number] => {
    const title = recommendation.__typename == 'RecommendedArticle' ? recommendation.title : ''

    const link: Links[number] = {
      type: 'standard',
      href: recommendation.href,
      text: title,
      clickHandler: () => {
        dynamicGa4DataLayerPush({
          event: 'notification_ab_test',
          item_text: title,
          item_parent_text: sectionTitle,
          item_group: whichId,
        })
      },
    }

    return link
  })

  return links
}

type RecommendationsTextLinksLayoutProps = {
  content: RecommendedContentType[]
  title: string
  whichId: string
  modelId: string
}

export const RecommendationsTextLinksLayout = ({
  content,
  title,
  whichId,
  modelId,
}: RecommendationsTextLinksLayoutProps) => (
  <MultiLinkBlock
    componentType={whichId}
    title={title}
    links={getLinks(content, title, whichId)}
    className={styles.recommendationTextLinks}
    data-which-id={whichId}
    data-parent-text={modelId}
  />
)
